import {useEffect, useState} from 'react';

import {fetchData} from './fetch-data';

const API_URL = `${window.Site.ratingDomain}api/nominations/ratings`;

export const useGolosNarodaWidgetData = () => {
  const [widgetCategories, setWidgetCategories] = useState([]);

  useEffect(
    () => {
      fetchData({apiUrl: API_URL}).then(
        categories => {
          if (categories && categories.length) {
            setWidgetCategories(categories.slice(0, 4));
          }
        }).catch(console.error);
    },
    []
  );

  return widgetCategories;
};
